import { PROPERTY_GROUP_STATUS } from '@ibe/constants';
import { z } from 'zod';

const CODE_MIN = 2;
const CODE_MAX = 40;
const NAME_MAX = 200;
const DESCRIPTION_MAX = 4000;

const statusSchema = z.enum(Object.values(PROPERTY_GROUP_STATUS) as [string, ...string[]]);

export const propertyGroupFormFields = {
  code: z
    .string()
    .trim()
    .toUpperCase()
    .min(CODE_MIN, 'Code must be at least 2 characters')
    .max(CODE_MAX, 'Code must be 40 characters or fewer')
    .regex(/^[A-Z0-9-]+$/, 'Code can only contain uppercase letters, digits and hyphens'),
  name: z
    .string()
    .trim()
    .min(1, 'A name is required')
    .max(NAME_MAX, 'Name must be 200 characters or fewer'),
  description: z
    .string()
    .trim()
    .max(DESCRIPTION_MAX, 'Description must be 4000 characters or fewer')
    .nullish(),
  status: statusSchema,
  propertyIds: z.array(z.uuid()),
};

export const propertyGroupFormInput = z.object(propertyGroupFormFields);

export const propertyGroupRow = z.object({
  id: z.string(),
  code: z.string().optional(),
  name: z.string().optional(),
  description: z.string().nullable().optional(),
  status: z.string().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
});

export const propertyGroupDetail = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  status: z.string(),
  propertyIds: z.array(z.string()),
  createdAt: z.string(),
  updatedAt: z.string(),
  version: z.number(),
});

export type PropertyGroupRow = z.infer<typeof propertyGroupRow>;
export type PropertyGroupDetail = z.infer<typeof propertyGroupDetail>;
export type PropertyGroupFormInput = z.infer<typeof propertyGroupFormInput>;
